var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}

site.boxman = {
	init: function () {
		$("#dialog").on("dialogopen", function (event, ui) {
			site.boxman.waitUntil(function () {
				return $('input#class.hidden').length > 0;
			}, function () {
				$('input#class.hidden').removeClass('hidden').addClass('text').attr('type', 'text').wrap('<dd id="class-element" />').wrap('<span class="lmnt" />').closest('dd').prepend('<dt id="class-label"><label for="class" class="optional">Auka klasar</label></dt>');
			}, function () {
			});
		});
	},
	waitUntil: function (isready, success, error, count, interval) {
		if (count === undefined) {
			count = 100;
		}
		if (interval === undefined) {
			interval = 20;
		}
		if (isready()) {
			success();
			return;
		}
		// The call back isn't ready. We need to wait for it
		setTimeout(function () {
			if (!count) {
				// We have run out of retries
				if (error !== undefined) {
					error();
				}
			} else {
				// Try again
				site.boxman.waitUntil(isready, success, error, count - 1, interval);
			}
		}, interval);
	}
};

site.pilotfront = {
	init: function() {
		if($('#pilotfront .expandable')) {
			site.pilotfront.expandable();
		}
	},
	expandable: function() {
		$('#pilotfront .expandable .inner > .content').each(function () {
			var $this = $(this);
			$this.css('max-height', $this[0].scrollHeight);
		});
		$('#pilotfront .expandable .itemWrap').click(function(e) {
			e.preventDefault();
			$(this).parents('.item').toggleClass('open');
		});
	},
}

site.extras = {
	init: function() {
		if($('#extras .category.veislurnar')) {
			site.extras.veislurnar();
		}
		if($('#extras .detailed.level2')) {
			site.extras.matsedlar();
		}
		if($('#extras .thjonusta')) {
			site.extras.thjonusta();
		}
		if($('#extras .ummaeli')) {
			site.extras.ummaeli();
		}
	},
	veislurnar: function() {
		$items = $('#extras .items');
		$('#extras .items .item.hasImage').each(function() {
			site.owl.init('#'+$(this).attr('id')+' .images', {
				nav:true,
				navText:['<i class="fa fa-angle-left" />','<i class="fa fa-angle-right" />'],
				items:1,
				dots:false
			});
		});
		$('#extras .category.veislurnar .title').click(function() {
			$(this).parents('.item').toggleClass('open');
		});
	},
	matsedlar: function() {
		$('#extras .detailed.level2 .inner > .content').each(function () {
			var $this = $(this);
			$this.css('max-height', $this[0].scrollHeight);
		});
		$('#extras .detailed.level2 .itemWrap').click(function(e) {
			e.preventDefault();
			$(this).parents('.item').toggleClass('open');
		});
	},
	thjonusta: function() {
		$('#extras .thjonusta .content .btn-primary').parent().addClass('toBottom');
	},
	ummaeli: function() {
		var $it = $('#extras .ummaeli .level2 .items');
		var $image = $('#extras .ummaeli .level2 .wrapper');
		var $cat = $('#extras .ummaeli .level2');
		$('#extras .ummaeli .item .wrap > .content').each(function () {
			var $this = $(this);
			$this.css('max-height', $this[0].scrollHeight);
			//$this.css('display', 'none');
		});
		$image.click(function(e) {
			e.preventDefault();

			if ($(this).children('.items').hasClass('open')) {
				$(this).children('items').removeClass('open');
				$(this).parents('level2').removeClass('open');
				$(this).children('.items').toggleClass('open');
				$(this).parents('.level2').toggleClass('open');
				return;
			}

			$it.removeClass('open');
			$cat.removeClass('open');

			$(this).children('.items').toggleClass('open');
			$(this).parents('.level2').toggleClass('open');

		});
	}
};

site.menucarousel = {
	init: function() {
		site.owl.init('#menu .menuItems', {
			nav:true,
			navText:['<i class="fa fa-angle-left" />','<i class="fa fa-angle-right" />'],
			items:1,
			dots:false
		});
	}
};

site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.frontpage = {
	init: function() {
		site.owl.init('#owl-hero', {
			loop:false,
			nav:true,
			navText:['<i class="fa fa-angle-left"></i>','<i class="fa fa-angle-right"></i>'],
			items:1,
			dots: false,
			autoplay: false,
			smartSpeed: 750
		});
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	if ($('body').is('.frontpage')) {
		site.frontpage.init();
	}
	if ($('body').is('.extras')) {
		site.extras.init();
	}
	if ($('body').is('.pilotfront')) {
		site.pilotfront.init();
	}
	if ($('body').is('.menuCarousel')) {
		site.menucarousel.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		if ($('body').width()+15 <= 991) {
			$('table', '#main').wrap('<div class="table-responsive"></div>');
		}
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	$('.slideUp').on('click', function(event){
		event.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
	});
	if ($('body').width()+15 >= 992) {
		var $window = $(window),
			$document = $(document),
			slideUp = $('.slideUp');

		$window.on('scroll', function () {
			if (($window.scrollTop() + $window.height()) == $document.height() && !slideUp.hasClass('open')) {
				slideUp.addClass('open');
			}
			else {
				slideUp.removeClass('open');
			}
		});
	}

	$('.animateHash').on('click', function(e){
		e.preventDefault();
		$('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
	});

	var $form = $('#main .box_custom form');
	if($form.length) {
		$form.find('input[type="text"],textarea').focus(function () {
			$(this).parents('.elm').addClass('hastext');
		});
		$form.find('input[type="text"],textarea').blur(function () {
			if ($(this).val() == '') {
				$(this).parents('.elm').removeClass('hastext');
			}
		});
	}

	var $header = $('#header');
	$header.responsiveDom({
		appendTo: '#pageContainer',
		mediaQuery: 'screen and (max-width: 991px)',
	});
	var $header = $('#sidebar .searchToggle');
	$header.responsiveDom({
		appendTo: '#header',
		mediaQuery: 'screen and (max-width: 991px)',
	});


	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
